import React from 'react'
import util from 'meinian-package/src/utils/util'
import { PLATFORM_CONFIG_ENUM, ZK_PLATFORM_CONFIG_ENUM, ZK_DEFAULT_PLATFORM_CONFIG } from 'meinian-package/src/component/platformConfig'
import { toOriginLink } from '../../imageDetail/infoCase'

export default (props) => {
  const { platformId, children, className, style, item } = props

  const dto = item.isFromZkPlatform
    ? item[(ZK_PLATFORM_CONFIG_ENUM.get(item?.childPlatformId || platformId)?.dto || ZK_DEFAULT_PLATFORM_CONFIG.dto)]
    : item[PLATFORM_CONFIG_ENUM.get(item?.childPlatformId || platformId)?.dto] || {}

  const href = toOriginLink((item?.childPlatformId || platformId), { ...item, ...dto })
  // eslint-disable-next-line react/jsx-no-useless-fragment
  return <>{ href ? <a
    onClick={() => {
      util.track('mn-origin-link', {
        module1: '卡片',
        module2: '站内款式原文',
      })
    }}
    style={style}
    href={href}
    target="_blank"
    rel="noreferrer"
    className={className}
  >{children || '跳转原文'}</a> : <span>{children}</span>}</>
}
